module.exports = __webpack_public_path__ + "static/media/hora.11984bce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/RateCall/hora.svg
// module id = 1829
// module chunks = 0